"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.truncateTimeFrame = void 0;
var DEDUP_WINDOW_SIZE_MS = 3600 * 1000;
/**
* Truncates de time frame received with the time window.
*/
function truncateTimeFrame(timestampInMs) {
    return timestampInMs - (timestampInMs % DEDUP_WINDOW_SIZE_MS);
}
exports.truncateTimeFrame = truncateTimeFrame;
